export class EncryptionService {
    public async encrypt(plaintext:string, publicKey:string):Promise<string> {
        const algorithm = {name:"RSA-OAEP"}
        const pubkey = await this.importPubKey(publicKey)
        const plaintextEncoder = new TextEncoder().encode(plaintext)

        const encrypted = await window.crypto.subtle.encrypt(algorithm, pubkey, plaintextEncoder)

        return window.btoa(this.arrayBufferToString(encrypted))
    }

    // imports the public key savely int othe browser/window
    private async importPubKey(pubkey:string):Promise<CryptoKey> {
        // convert to base64 string and convert to arrayBuffer
        const buffer = this.stringToArrayBuffer(window.atob(pubkey))
        const algorithm = {name: "RSA-OAEP", hash: "SHA-1"}

        try {
            return await window.crypto.subtle.importKey("spki", buffer, algorithm, true, ["encrypt"])
        }
        catch (ex) {
            console.log("importing Key in Function failed",ex, pubkey, buffer)
            return new CryptoKey()
        }
    }

    private stringToArrayBuffer(value:string):ArrayBuffer {
        const buffer = new ArrayBuffer(value.length)
        const intBufferArray = new Uint8Array(buffer);

        for (let i = 0; i < value.length; ++i)
            intBufferArray[i] = value.charCodeAt(i);

        return buffer;
    }

    private arrayBufferToString(value:ArrayBuffer):string {
        return String.fromCharCode.apply(null, Array.from(new Uint8Array(value)))
    }
}